import React, { useEffect, useState, memo } from 'react';
import { useMEMTranslation } from '../../utils/text-utils';
import { useTrackInteraction } from '../../services/logging/hooks';
import { usePageContext } from '../../utils/page-context';
import { useAvailableManagerPartitionGroups } from './hooks';
import { Option, Combobox } from '../../providers/harmony-scope/lazy-enablers';

interface IProps {
  selectedPartitionGroupName: string;
  onChange: (partitionGroup: string) => void;
}

const componentName = 'Manager Partition Group Picker Filters Panel';
export const ComponentFilterManagerPartitionGroup = memo((props: IProps) => {
  // Props Accessors
  const { selectedPartitionGroupName: selectedPartitionGroupNameProp, onChange } = props;

  // Hooks
  const { t } = useMEMTranslation();
  const pageName = usePageContext();
  const trackInteraction = useTrackInteraction();
  const availablePartitionGroups = useAvailableManagerPartitionGroups();
  const [selectedPartitionGroupName, setSelectedPartitionGroupName] = useState(selectedPartitionGroupNameProp);

  // Effects
  useEffect(() => {
    setSelectedPartitionGroupName(selectedPartitionGroupNameProp);
  }, [selectedPartitionGroupNameProp]);

  useEffect(() => {
    onChange(selectedPartitionGroupName);
  }, [onChange, selectedPartitionGroupName]);

  // Handlers
  const partitionGroupChanged = (event: any) => {
    if (!event.target.value) return;
    const newPartitionGroup = event.target.value;
    trackInteraction('Selected manager partition group', pageName, componentName, {
      selectedManagerPartitionGroup: newPartitionGroup,
    });
    setSelectedPartitionGroupName(newPartitionGroup);
  };

  return (
    <>
      <Combobox label={t('filtersPanelPartitionCadenceLabel')} value={selectedPartitionGroupName} onHeChange={partitionGroupChanged}>
        {availablePartitionGroups.map((p) => (
          <Option key={`${p}`} value={`${p}`} title={`${p}`}>
            {`${p}`}
          </Option>
        ))}
      </Combobox>
      <br />
    </>
  );
});
